import { Icon } from "@hireart/component-library";
import chartBar2Icon from "hireart-icons/chart-bar-2.svg";
import chevronRightIcon from "hireart-icons/chevron-right.svg";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import { Button } from "hireart-components";

export const BillingDetails = ({
  billRate,
  canEditBillRate = false,
  onModalOpen,
  markup = "markup undetermined",
}) => {
  return (
    <Grid.Column>
      <p className="heading">{billRate}</p>
      <p>bill rate</p>
      <hr />
      <div className="card-spacer">
        {canEditBillRate ? (
          <Button
            className="termination-link is-not-padded"
            size="md"
            basic
            fluid
            onClick={onModalOpen}
          >
            Edit
            <Icon src={chevronRightIcon} className="chevron-icon" />
          </Button>
        ) : (
          <>
            <Icon src={chartBar2Icon} className="chevron-icon" /> {markup}
          </>
        )}
      </div>
    </Grid.Column>
  );
};

BillingDetails.propTypes = {
  billRate: PropTypes.string.isRequired,
  canEditBillRate: PropTypes.bool,
  onModalOpen: PropTypes.func.isRequired,
  markup: PropTypes.string,
};
